import { useLocation } from "react-router-dom";

export function useSearchValue(): string {
  const location = useLocation();
  return new URLSearchParams(location.search).get("value") ?? "";
}
